/**
 * Consulting B2B - All Projects Page
 * Consulting projects management
 */

import { useEffect } from 'react';
import { AllProjectsPage } from '@/components/industry/pages/AllProjectsPage';
import { CompanyType } from '@/types/company';
import { MainLayout } from "@/components/MainLayout";

export default function ConsultingProjectsPage() {
  useEffect(() => {
    document.title = 'Todos os Projetos | Controle Financeiro';
  }, []);

  return (
<MainLayout>
    <div className="container mx-auto py-6">
      <AllProjectsPage
        domain={CompanyType.CONSULTING_B2B}
        title="Todos os Projetos"
        description="Gerencie seus projetos de consultoria empresarial"
        createButtonLabel="Novo Projeto"
      />
    </div>
  
    </MainLayout>);
}

